import deleteTrashCan from "assets/img/delete-trash-can.svg";
import Button from "components/Button";
import { Card, CardList } from "components/Card";
import Icon from "components/Icon";
import Table from "components/Table";
import { RouteProps } from "containers/App";
import CreateBreadcrumb from "containers/CreateBreadcrumb";
import ProjectFilter, { FilterOptions } from "containers/ProjectFilter";
import { File } from "interfaces/file";
import { FetchAllStoresOrFilesQueryOptions } from "interfaces/filterQuery";
import React from "react";
import Popover from "react-popover";
import { connect, ConnectedProps } from "react-redux";
import { State } from "state";
import { deleteFileMappings, fetchAllFiles } from "state/files";
import { fetchStoresByProjectId } from "state/stores";
import moment from "moment";
import Loader from "components/Loader";
import { sortStoreNumbersMixed } from "utils/sorters";
import { resolveStoreIdsForProject } from "utils/storeIds";

type ManageFilesProps = PropsFromRedux & RouteProps;

interface ManageFilesState {
  tableData: File[];
  projectId: number;
  popoverOpenId: number | null;
  isLoading: boolean;
  hasProjectParam: boolean;
  storeIds: string;
}

class MnagePSAFiles extends React.Component<ManageFilesProps, ManageFilesState> {
  state = { tableData: [], projectId: 0, popoverOpenId: null, isLoading: false, hasProjectParam: false, storeIds: "" };

  private resolveStoreIds = async (projectId: number) => {
    return resolveStoreIdsForProject({
      projectId,
      storeIdsInState: this.state.storeIds,
      storesInContext: this.props.stores || [],
      fetchStoresByProjectId: this.props.fetchStoresByProjectId,
    });
  };

  private loadProjectFiles = async (projectId: number) => {
    const storeIds = await this.resolveStoreIds(projectId);
    const queryOptions: FetchAllStoresOrFilesQueryOptions = {
      includeNullStore: true,
      ...(storeIds ? { storeIds } : {}),
    };

    await this.props.fetchAllFiles(projectId, queryOptions);

    this.setState({
      tableData: this.props.allMapFiles || [],
      storeIds,
      isLoading: false,
    });
  };

  public handleDelete(mappingId: string | number, maptype: "Store" | "Project") {
    this.props.deleteFileMappings(mappingId, maptype).then(() => {
      this.loadProjectFiles(this.state.projectId).then(() => {
        this.setState({
          tableData: this.props.allMapFiles || [],
        });
      });
    });
  }

  public togglePopoverOpenId(id: number) {
    this.setState({ popoverOpenId: this.state.popoverOpenId ? null : id });
  }
  componentDidMount() {
    const projectIdParam = (this.props as any).match?.params?.projectId;

    if (projectIdParam) {
      const projectIdNum = parseInt(projectIdParam, 10);
      this.setState({ projectId: projectIdNum, isLoading: true, hasProjectParam: true });
    }
  }

  componentDidUpdate(prevProps: ManageFilesProps, prevState: ManageFilesState) {
  if (prevState.projectId !== this.state.projectId && this.state.projectId > 0) {
    this.setState({ isLoading: true });

    this.loadProjectFiles(this.state.projectId);
  }
}

  public render() {
    const psaFiles = (this.state.tableData || []).filter((file : any) =>
        file?.name?.toLowerCase().endsWith(".psa")
        );

    return (
      <section className="manage-data-container">
        <CreateBreadcrumb
          crumbs={{
            crumbs: [
              {
                to: "/manage-all-data",
                crumb: "VIEW ALL DATA",
                dataQa: "view-all-data-link",
              },
            ],
          }}
        />
        <div className="manage-data-body">
          <h1 className="header">Manage Files</h1>
          <div className="manage-data-table-controls" data-qa="project-dropdown">
            <ProjectFilter
              onChange={({ id }: FilterOptions) => {
                if (!this.state.hasProjectParam) {
                  this.setState({
                    isLoading: true,
                    storeIds: "",
                    projectId: id,
                  });
                }
              }}
              isSearchable={!this.state.hasProjectParam}
              isDisabled={this.state.hasProjectParam}
               value={this.state.projectId || undefined} 
            />
          </div>
          {this.state.isLoading ? (
            <Loader />          
          ) : (
          <CardList>
            <Card>
              <Table
                data={psaFiles || []}
                emptyState="Select a project and search to view file data"
                columns={[
                  {
                    field: "maptype",
                    header: "FILE TYPE",
                    dataQa: "file-type",
                  },
                  {
                    field: "name",
                    header: "FILE NAME",
                    dataQa: "file-name",
                  },
                  {
                    field: "storeno",
                    header: "STORE NO.",
                    dataQa: "store-number",
                    sortMethod: (a: string | number, b: string | number) => sortStoreNumbersMixed(a, b),
                  },
                  {
                    field: "user_name",
                    header: "Uploaded By",
                    wrap: true,
                    dataQa: "uploaded-by",
                  },
                  {
                    field: "updated_at",
                    header: "Upload Date",
                    wrap: true,
                    dataQa: "upload-date",
                    formatter: (value) => {
                      const date = moment(value);

                      if (!date.isValid()) {
                        return "--";
                      }

                      return date.format("M/D/YYYY h:mm A");
                    },
                  },
                  {
                    field: "",
                    header: "",
                    sortable: false,
                    dataQa: "delete-filemap",
                    formatter: (row: any, index: number) => {
                      return (
                        <Popover
                          body={
                            <div
                              style={{
                                display: "flex-inline",
                              }}
                            >
                              <p>Delete mapping for this file?</p>
                              <Button
                                data-qa="confirm-delete-button"
                                warning={true}
                                style={{
                                  padding: "6px 12px",
                                  borderRadius: 4,
                                  background:  "#E5B42F",
                                  color: "#0F0F0F",
                                  border: "none",
                                  cursor: "pointer",
                                }}
                                onClick={(e) => this.handleDelete(row.mapid, row.maptype)}
                              >
                                DELETE
                              </Button>
                              <Button
                                data-qa="cancel-delete-button"
                                secondary={true}
                                style={{
                                  padding: "6px 12px",
                                  borderRadius: 4,
                                  color: "#0F0F0F",
                                  border: "none",
                                  cursor: "pointer",
                                }}
                                onClick={(e) => this.togglePopoverOpenId(index)}
                              >
                                CANCEL
                              </Button>
                            </div>
                          }
                          isOpen={this.state.popoverOpenId === index}
                          preferPlace="left"
                        >
                          <button
                            style={{ outline: "none" }}
                            className="delete-comment-button"
                            data-qa="delete-button"
                            onClick={(e) => this.togglePopoverOpenId(index)}
                          >
                            <Icon medium={true} src={deleteTrashCan} />
                          </button>
                        </Popover>
                      );
                    },
                  },
                ]}
              />
            </Card>
          </CardList>
        )}
        </div>
      </section>
    );
  }
}

const connecter = connect(
  (state: State) => ({
    projects: state.my_projects.content,
    allMapFiles: state.files.content?.data,
    stores: state.stores.content?.data,
  }),
  { fetchAllFiles, fetchStoresByProjectId, deleteFileMappings }
);

type PropsFromRedux = ConnectedProps<typeof connecter>;

export default connecter(MnagePSAFiles);
